import { render, staticRenderFns } from "./Taxation.vue?vue&type=template&id=09468fa6&scoped=true&"
import script from "./Taxation.vue?vue&type=script&lang=js&"
export * from "./Taxation.vue?vue&type=script&lang=js&"
import style0 from "./Taxation.vue?vue&type=style&index=0&id=09468fa6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09468fa6",
  null
  
)

export default component.exports